module.exports = __webpack_public_path__ + "static/media/arrow.95f047c2.svg";